import { Song } from '@repo/types'

import { normalizeString } from './normalizeString'

export function createNormalizedSongTitle(song: Song) {
  return `${normalizeString(song.artist)}-${normalizeString(song.title)}`
}
